import * as BaseComp from 'components/bolt/text/text.js';
import { trackSocialFollow } from 'utils/track.js';
import { smoothScrollTo } from 'utils/smoothScroll';

export default class Text extends BaseComp.default {
    onClick(e) {
        super.onClick(e);
        const link = e.target.closest('a');
        const id = link?.id;
        
        if (id === 'follow-twitter' || id === 'follow-facebook' || id === 'follow-instagram' || id === 'follow-youtube') {
            trackSocialFollow(id);
        }
		const href = link.getAttribute('href');
        if (href && (href.endsWith('#$hubScroll'))) {
			e.preventDefault();
            // Scroll to the top of the page when "Home" is clicked
			const topElement = document.querySelector('div[data-section="hub"]');
			if (topElement) {
				topElement.scrollIntoView({ behavior: 'smooth' });
			}
		}
        if (href.endsWith('#$aboutUsScroll')) {
			e.preventDefault();
            // Scroll to the top of the page when "About Us" is clicked
			const topElement = document.querySelector('div[data-hash-wrapper="gallery"]');
			if (topElement) {
				topElement.scrollIntoView({ behavior: 'smooth' });
			}
		}
        if (href.endsWith('#$contactScroll')) {
			e.preventDefault();
            // Scroll to the top of the page when "Contact" is clicked
			const topElement = document.querySelector('div[data-hash-wrapper="contact"]');
			if (topElement) {
				topElement.scrollIntoView({ behavior: 'smooth' });
			}
		}
    }
}